
import { SET_ROSTER } from "../actions/action_roster";
import { SET_COL1 } from "../actions/action_roster";
import { SET_COL2 } from "../actions/action_roster";
import { SET_COL3 } from "../actions/action_roster";
import { SET_CURRTAB } from "../actions/action_roster";

const initialState = {
  scores: [],
  cols: [],
  col1: [],
  col2: [],
  col3: [],
  numRows: 0,
  currTab: 1
}

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_ROSTER:
      let length;
      let scores;
      let curCols;
      if(state.currTab === 2) {
        length = action.payload.length;
        scores = action.payload;
        curCols = state.col1;
      } else {
        length = action.payload.ind.length;
        scores = action.payload.ind;
        curCols = state.col2;
      }
      newState = {
        scores: scores,
        numRows: length,
        cols: curCols
      };
      return { ...state, ...newState };
    case SET_COL1:
      return { ...state, col1: action.payload };
    case SET_COL2:
      return { ...state, col2: action.payload };
    case SET_COL3:
        newState = {
          col3: action.payload,
          cols: action.payload
        };
        return { ...state, ...newState };
    case SET_CURRTAB:
      if(action.payload === 1){
        newState = {
          cols: state.col3,
          currTab: action.payload
        };
        return { ...state, ...newState };
      } else {
        return { ...state, currTab: action.payload };
      }
    default:
      return state;
  }
}
